import { Lang } from '../hooks/useLocale';

export const isKana = (value: string) => /^([ァ-ン]|ー)+$/.test(value);
export const isAlphabet = (value: string) => /^[A-Za-z]+$/.test(value);

export const isValidName = (value: string, lang: Lang): boolean => (lang === 'en' ? isAlphabet(value) : isKana(value));
